import { useContext } from 'react';

import { SubscriptionContext } from '~/utils';

const useTopics = (topic) => {
  const { topics } = useContext(SubscriptionContext);

  if (Array.isArray(topic)) {
    return topic.map(t =>
      topics[t]);
  } else if (typeof topic === 'string') {
    return topics[topic];
  }

  return topics;
};

export default useTopics;
